module.exports = __webpack_public_path__ + "img/医.295cdea3.png";